export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          关于我们
        </h2>
        <p className="text-foreground-600 text-sm text-center mb-10 md:mb-14 max-w-xl mx-auto">
          了解星球漫画的故事与使命
        </p>
        <div className="max-w-[800px] mx-auto bg-background-100 rounded-2xl p-8 md:p-10">
          <div className="flex flex-col md:flex-row gap-8 items-start">
            <div className="shrink-0">
              <div className="w-20 h-20 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-planet-line text-3xl text-background-50"></i>
              </div>
            </div>
            <div>
              <h3 className="font-heading text-xl text-foreground-900 mb-4">
                星球漫画 — 为每一位漫画爱好者而生
              </h3>
              <div className="text-foreground-600 text-sm leading-relaxed space-y-3">
                <p>
                  星球漫画创立于对漫画的热爱。我们深知漫画爱好者对于优质免费漫画内容的渴望，因此打造了这个汇集海量免费漫画资源的在线阅读平台。从热血冒险到治愈温情，从国漫经典到日漫佳作，星球漫画致力于成为中文互联网上最全面的免费漫画网站大全。
                </p>
                <p>
                  我们坚持免费漫画的核心理念，所有内容免VIP即可阅读全集，让每一位读者都能平等享受漫画带来的快乐。同时，我们通过下拉式阅读技术持续优化阅读体验，确保在桌面端和移动端都能获得流畅舒适的阅读感受。
                </p>
                <p>
                  未来，星球漫画将继续拓展漫画资源库，引入更多优质好看的免费漫画作品，并持续优化平台功能，为漫画爱好者提供更好的免费在线漫画阅读服务。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}